<script setup lang="ts">
import router from '@/router'

import { RHDHVHeader, useEventsBus } from '@haskoning/vue-component-library'
import { useDjangoAuthStore } from '@/stores/authDjango'

const authStore = useDjangoAuthStore()
const { user } = storeToRefs(authStore)

const { bus } = useEventsBus()

const loading = ref(false)

watch(
  () => bus.value.get('loading'),
  (val) => {
    loading.value = val[0]
  }
)

const logout = async () => {
  await authStore.logout()
  authStore.$patch({
    user: null
  })
  await router.push({ name: 'auth-login' })
}
</script>

<template>
  <RHDHVHeader
    v-if="user"
    title="SHIP"
    :user="user"
    image-src="/logo-white.png"
    :loading="loading"
    menuColor="white"
    @logout="logout"
  >
  </RHDHVHeader>
</template>
